import eventBus from '@/plugins/event-bus.ts';

type EventHandler = (payload?: any) => void;

export const useEventBus = () => {
    return {
        emit: (eventName: string, ...args: any[]): void => {
            eventBus.$emit(eventName, ...args);
        },
        on: (event: string | string[], callback: EventHandler): void => {
            eventBus.$on(event, callback);
        },
        off: (event?: string | string[], callback?: EventHandler): void => {
            eventBus.$off(event, callback);
        },
    };
};
